import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BulkOperationType } from 'listings/enums/bulk-operation-type.enum';
import { Observable } from 'rxjs';

const USER_API = environment.BASE_URL + 'userApi';

@Injectable({
    providedIn: 'root',
})
export class ExportsService {
    constructor(private http: HttpClient) {}

    public runFullExport(operationType: BulkOperationType, values: any): Observable<any> {
        return this.http.post(
            USER_API + '/bulkOperation/start-full-export-operation',
            { operationInformation: JSON.stringify(values) },
            { params: { operationType: operationType } },
        );
    }
}
